import { Navigate, useLocation } from 'react-router-dom';
import { Root } from '../layouts';
import { useAuth } from '../contexts';
import { useEffect, useRef } from 'react';
import { Spin } from 'antd';

const Protected = () => {
  const { isAuthenticated, isLoading, sessionLimitData } = useAuth();
  const location = useLocation();
  const initialRender = useRef(true);

  useEffect(() => {
    // Skip the effect on the initial render
    if (initialRender.current) {
      initialRender.current = false;
      return;
    }

    // Set redirect path only when not authenticated
    if (!isAuthenticated) {
      localStorage.setItem('redirectPath', location.pathname);
    }
  }, [isAuthenticated, location.pathname]);

  // While checking auth status, don't redirect
  if (isLoading || isAuthenticated === null) {
    return (
      <Spin
        tip={
          <div className="text-white/70 text-sm font-normal mt-2">
            Please wait..
          </div>
        }
        size="large"
        fullscreen
      />
    );
  }

  const publicRoutes = [
    '/reset-password',
    '/forgot-password',
    '/signin',
    '/onboarding',
    '/mail-approval',
    '/device-limit',
  ];

  // If device limit is active, only allow /device-limit — block everything else
  if (sessionLimitData && location.pathname !== '/device-limit') {
    return <Navigate to="/device-limit" replace />;
  }

  if (!isAuthenticated && !publicRoutes.includes(location.pathname)) {
    return <Navigate to="/signin" replace />;
  }

  return <Root />;
};

export default Protected;
